export enum MeioPagamento {
  BOLETO = 'BOLETO',
  CARTAO_CREDITO = 'CARTAO_CREDITO',
  PIX = 'PIX'
}
